import categories from '../components/ResourceSidebar/categories.json';

let _resources = [];

export const isEDMode =
  typeof window !== "undefined"
    ? window.location.href.indexOf("ed=1") > 0
    : false;

export const getUrlParameter = (param) => {
  param = param.replace(/[\\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + param + "=([^&#]*)");
  const results = regex.exec(window.location.search);

  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};


export const focusLoop = (e, selector) => {
	const tabPressed = e.key === 'Tab' || e.keyCode === 9;

	if (!tabPressed) return;

	const elems = document.querySelectorAll(selector)

	if (elems?.length) {
		const firstElem = elems[0];
		const lastElem = elems[elems.length - 1];

		if (!Array.from(elems).includes(document.activeElement)) {
			firstElem.focus();
		}

		if (e.shiftKey) {
			if (document.activeElement === firstElem) {
				lastElem.focus();
				e.preventDefault();
			}
		} else {
			if (document.activeElement === lastElem) {
				firstElem.focus();
				e.preventDefault();
			}
		}
	}
}


export const resourcesHelper = {
	// Function to set resources data
	setResources: (resourcesData) => {
		_resources = resourcesData;
		return _resources;
	},


	createBatches: (filters, resources = _resources) => {
		let batches = [];
		let batch = [];

		if (filters.Speciality[0] === 'All' && !filters.Topic.length && !filters.Type.length) {
			categories.Speciality.forEach((speciality) => {

				batch = [{
					id: speciality + '-' + Math.random().toString(36).substring(2, 15),
					__typename: 'ResourceBlock',
					title: speciality,
					items: []
				}]
				resources.forEach((resource) => {
					if (resource.metadata.tags.some(tag => tag.name.toLowerCase().indexOf(speciality.toLowerCase()) > -1)) {
						batch[0].items.push(resource);
					}
				})
				if (batch[0].items.length) {
					batches.push(...batch);
				}
			})
		}
		else if (filters.Speciality.length && filters.Topic.length) {

			batch = [{
				id: filters.Topic[0] + '-' + Math.random().toString(36).substring(2, 15),
				__typename: 'ResourceBlock',
				title: filters.Topic[0],
				items: [...resources]
			}]
			// resources.forEach((resource) => {
			// 	if (resource.metadata.tags.some(tag => tag.name.toLowerCase() === ('topic:' + filters.Topic[0].toLowerCase()))) {
			// 		batch[0].items.push(resource);
			// 	}
			// })

			batches.push(...batch);

		} else if (filters.Speciality.length) {
			batch = [{
				id: filters.Speciality[0] + '-' + Math.random().toString(36).substring(2, 15),
				__typename: 'ResourceBlock',
				title: filters.Speciality[0],
				items: [...resources]
			}]

			batches.push(...batch);

		}

		return batches;
	},

	filterData: (filters, resources = _resources) => {
		if (!resources || !resources.length) return [];

		// Create a copy to avoid modifying the original resources
		let filteredResources = [...resources];

		try {
			// Apply speciality filter
			if (filters?.Speciality?.length) {
				filteredResources = filteredResources.filter(resource => {
					if (!resource?.metadata?.tags) return false;

					const tagNames = resource.metadata.tags.map(tag => tag.name.toLowerCase());
					return filters.Speciality.some(speciality => 
						speciality === 'All' ? true : tagNames.some((tag) => {
							return tag.toLowerCase() === ('specialty:' + speciality.toLowerCase())
						})
					);
				});
			}

			// Apply topic filter
			if (filters?.Topic?.length) {
				filteredResources = filteredResources.filter(resource => {
					if (!resource?.metadata?.tags) return false;

					const tagNames = resource.metadata.tags.map(tag => tag.name.toLowerCase());
					return filters.Topic.some(topic =>
						tagNames.some((tag) => {
							return tag.toLowerCase() === ('topic:' + topic.toLowerCase())
						})
					);
				});
			}

			// Apply type filter
			if (filters?.Type?.length) {
				filteredResources = filteredResources.filter(resource => {
					if (!resource?.metadata?.tags) return false;

					const tagNames = resource.metadata.tags.map(tag => tag.name.toLowerCase());
					return filters.Type.some(type =>
						tagNames.some((tag) => {
							return tag.toLowerCase() === ('type:' + type.toLowerCase())
						})
					);
				});
			}
			// Use createBatches if needed 
			return resourcesHelper.createBatches(filters, filteredResources);
		} catch (error) {
			console.error('Error in filterData:', error);
			return filteredResources;
		}
	}
};
